import React from "react";
import { Trans } from "react-i18next";

import {
  Callout,
  Button,
  InputGroup,
  Tag,
  Dialog,
  Classes,
  FormGroup,
  Icon,
  Checkbox
} from "@blueprintjs/core";

import {
  Cell,
  Column,
  ColumnHeaderCell,
  RowHeaderCell,
  Table2
} from "@blueprintjs/table";

import {
  authenticatedGetFetch,
  authenticatedDeleteFetch,
  authenticatedPutFetch
} from "../../../utils/AuthenticatedFetch";

export default class ParkTable extends React.Component {
  constructor() {
    super();
    this.state = {
      servers: [],
      parks: [],
      editing: -1
    };
  }

  componentDidMount() {
    this.updateTable();
  }

  updateTable() {
    authenticatedGetFetch('/servers', (response) => {
      const servers = [];
      for (const server of response)
        servers.push({ value: server.id, label: server.name });
      this.setState({ servers: servers })
    });
    authenticatedGetFetch('/parks', (response) => this.setState({ parks: response }));
  }

  render() {
    return <Callout title={<Trans>parks</Trans>}>
      <Callout intent="primary">parks are automatically created if missing when a state is received</Callout>

      {/* editing dialog */}
      <Dialog
        style={{ transition: 'none' }}
        isOpen={this.state.editing >= 0}
        onClose={() => this.setState({ editing: -1, creating_error: false })}
        title={<Trans>edit a park</Trans>}
      >
        <div className={Classes.DIALOG_BODY}>
          <form onSubmit={(e) => {
            e.preventDefault();
            authenticatedPutFetch("/park/" + this.state.parks[this.state.editing]["id"], {
              serverId: this.state.input_server.id,
              id: this.state.parks[this.state.editing]["id"],
              name: this.state.input_name,
              capacity: this.state.input_capacity,
              saturation_threshold: this.state.input_saturation_threshold,
              display: this.state.input_display
            }, () => this.setState({ editing: -1, creating_error: false }, () => this.updateTable()),
              () => this.setState({ creating_error: true }))
          }}>

           

            <FormGroup label={<Trans>server</Trans>} labelFor="input_server" inline={true}>
            <Tag large={true}>{this.state?.input_server?.name}</Tag>
            </FormGroup>

            <FormGroup label={<Trans>id</Trans>} labelFor="input_id" inline={true}>
              <Tag large={true}>{this.state.input_id}</Tag>
            </FormGroup>

            <FormGroup label={<Trans>name</Trans>} labelFor="input_name" inline={true}>
              <InputGroup id="input_name" intent={this.state.creating_error ? "danger" : "normal"}
                onChange={(ti) => this.setState({ input_name: ti.target.value })}
                value={this.state.input_name}
              />
            </FormGroup>

            <FormGroup label={<Trans>capacity</Trans>} labelFor="input_capacity" inline={true}>
              <InputGroup id="input_capacity" intent={this.state.creating_error ? "danger" : "normal"} type="number"
                onChange={(ti) => this.setState({ input_capacity: ti.target.value })}
                value={this.state.input_capacity}
              />
            </FormGroup>
            
            <FormGroup label={<Trans>saturation threshold</Trans>} labelFor="input_saturation_threshold" inline={true}>
              <InputGroup id="input_saturation_threshold" intent={this.state.creating_error ? "danger" : "normal"} type="number"
                onChange={(ti) => this.setState({ input_saturation_threshold: ti.target.value })}
                value={this.state.input_saturation_threshold}
              />
            </FormGroup>

            <FormGroup label={<Trans>display</Trans>} labelFor="input_display" inline={true}>
              <Checkbox id="input_display" intent={this.state.creating_error ? "danger" : "normal"} type="number"
                onChange={(ti) => this.setState({ input_display: ti.target.checked })}
                checked={this.state.input_display}
              />
            </FormGroup>

            <Button
              text={<Trans>edit</Trans>}
              intent="primary"
              icon="edit"
              type="submit"
            />
          </form>
        </div>
      </Dialog>

      <Table2
        cellRendererDependencies={[this.state.parks]}
        numRows={this.state.parks.length}
        rowHeaderCellRenderer={(rowIndex) => <RowHeaderCell index={rowIndex} name={this.state.parks[rowIndex]["id"]} />}
      >
        {/* server */}
        <Column
          id="server"
          cellRenderer={(rowIndex) => {
            if (this.state.parks[rowIndex]["server"])
              return <Cell>{this.state.parks[rowIndex]["server"]["name"]}</Cell>
            else
              return <Cell></Cell>
          }}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>server</Trans>} />}
        />

        {/* label */}
        <Column
          id="label"
          cellRenderer={(rowIndex) => <Cell>{this.state.parks[rowIndex]["name"]}</Cell>}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>label</Trans>} />}
        />

        {/* capacity */}
        <Column
          id="capacity"
          cellRenderer={(rowIndex) => <Cell>{this.state.parks[rowIndex]["capacity"]}</Cell>}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>capacity</Trans>} />}
        />
        
        {/* capacity */}
        <Column
          id="capacity"
          cellRenderer={(rowIndex) => <Cell>{this.state.parks[rowIndex]["saturation_threshold"]}</Cell>}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>saturation threshold</Trans>} />}
        />

        {/* display */}
        <Column
          id="display"
          cellRenderer={(rowIndex) => <Cell>{this.state.parks[rowIndex]["display"] ? <Icon intent="success" icon="tick" /> : <Icon icon="cross" intent="danger" />}</Cell>}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>display</Trans>} />}
        />

        {/* buttons */}
        <Column
          id="action"
          cellRenderer={(rowIndex) =>
            <Cell>
              <div className="flexbox-center">
                {/* {JSON.stringify(this.state.parks[rowIndex])} */}
                <Tag
                  icon="cog"
                  interactive={true}
                  minimal={true}
                  onClick={() => this.setState({
                    editing: rowIndex,
                    input_server: this.state.parks[rowIndex]["server"],
                    input_id: this.state.parks[rowIndex]["id"],
                    input_name: this.state.parks[rowIndex]["name"],
                    input_ip: this.state.parks[rowIndex]["ip"],
                    input_capacity: this.state.parks[rowIndex]["capacity"],
                    input_saturation_threshold: this.state.parks[rowIndex]["saturation_threshold"],
                    input_display: this.state.parks[rowIndex]["display"]
                  })}
                />
                <Tag
                  icon="trash" intent="danger"
                  interactive={true}
                  minimal={true}
                  onClick={() =>
                    authenticatedDeleteFetch("/park/" + this.state.parks[rowIndex]["pk"], {
                      name: this.state.input_name,
                      ip: this.state.input_ip
                    }, () => this.updateTable(), console.log("can't delete park, lonked payments ?"))
                  }
                />
              </div>
            </Cell>
          }
          columnHeaderCellRenderer={(index) => {
            return <ColumnHeaderCell index={index} />;
          }}
        />
      </Table2>
    </Callout>
  }
}